import React from "react";
import SingleInput from "./SingleInput";
import Axios from "axios";
import Helmet from "react-helmet";
import Loading from "./Loading";
import ServiceError from "./ServiceError";
import Analytics from "../utils/analytics";
import {addBmTelemetryToHeaders} from './../utils/addBmTelemetryToHeaders'
import {generateTransId} from './../utils/generateTransId';
import {getCorrelationId} from './../utils/getCorrelationId';
import getBlackBoxValues from '../utils/getBlackBoxValues'

const FormError = props => (
    <div>
        <span className="alert-form">
            The information you entered does not match ours. Please try again.
        </span>
    </div>
);

export default class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userid: "",
            password: "",
            redirecturi: "",
            redirect: false,
            loadingVisible: false,
            serviceError: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // Analytics: Set screen specific params
        let analytics = new Analytics(
            {
                page_sub_function: "login",
                page_name: "start",
                page_function: "login",
                device: "mobi",
                country_language: "en"
            },
            this.props.config
        );

        // Send update on "page load"
        analytics.triggerBootstrap();

        // Show pin timeout error (redirected from pin screen)
        if (this.props.pinTimeoutErr) {
            this.setState({
                serviceError: [
                    `Login timeout.  Please login again to link your account.`,
                    "",
                    ""
                ]
            });
        }

        // tell Ensighten SDK that _SFDDL has been updated
        /* let ensighten = window.Bootstrapper;

        try {
            ensighten.ensEvent.trigger("voice-page-load");
        } catch (e) {
            console.error(e);
        }*/
    }
    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.id;

        this.setState({ [name]: value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ serviceError: false });
        if (this.state.userid.length === 0) {
            this.setState({
                userIdError: "true"
            });
        } else {
            this.setState({ userIdError: "" });
        }
        if (this.state.password.length === 0) {
            this.setState({ pwdError: "true" });
        } else {
            this.setState({ pwdError: "" });
        }
        if (
            this.state.password.length !== 0 &&
            this.state.userid.length !== 0
        ) {
            //fetch data
            this.getData();
        }
    }

    async getData() {
        let prodInfo = this.props.config;

        const errorMsgs = {
            "2010": [
                `This account is locked, please contact customer service at ${
                    prodInfo.custservice_num
                }.`,
                "",
                ""
            ],
            "1012": [
                `The information you entered does not match ours. You have 1 login attempt remaining before a password reset will be required`,
                "",
                ""
            ],
            "2011": [`Your password has expired`, "", ""],
            "2013": [
                `You are not authorized to login. Please contact customer service at ${
                    prodInfo.custservice_num
                }.`,
                "",
                ""
            ],
            "1006": [
                `You are not authorized to login. Please contact customer service at ${
                    prodInfo.custservice_num
                }.`,
                "",
                ""
            ],
            "1001": [`Invalid User ID / Password`, "", ""],
            "2001": [`Invalid User ID / Password`, "", ""], //'2007': 'Your account is not yet registered.  Please visit register <a href="https://www.synchronycredit.com/amazon">here</a>.', //'Login Failed',
            "2007": [
                `Your account is not yet registered. `,
                prodInfo.account_register_url,
                "Please register at this link"
            ],
            "503": [
                `We are sorry there has been a service error.  Please try again later.`,
                "",
                ""
            ],
            "1003": [
                `We are sorry there has been a service error.  Please try again later.`,
                "",
                ""
            ],
            "400": [`Invalid User ID / Password`, "", ""]
        }; //'Login Failed',

        const baseApiUrl =
            process.env.NODE_ENV === "production"
                ? process.env.REACT_APP_PROD_API_URL
                : process.env.REACT_APP_DEV_API_URL;
        const loginApiUrl = baseApiUrl + "/v1/retailcard/identity/login/authenticate";
        const userId = this.state.userid.trim();
        const pwd = this.state.password.trim();

        // update with trimmed values
        this.setState({
            userid: userId,
            password: pwd
        });
        const data = {
          auth: {
            client_id: process.env.REACT_APP_CLIENT_ID,
            redirect_uri: process.env.REACT_APP_REDIRECT_URI,
            scope: 'account-linking',
            state: 'mEY9a6NpxrRk426loQC57T/gMbM1qz1/5kIoSxhA2Rs=',
            nonce: '',
          },
          device_info: {
            black_box: await getBlackBoxValues(),
          },
          user_info: {
            'cipher.password': pwd,
            user_id: userId,
          },
        };

        const reqHeaders = await addBmTelemetryToHeaders({
            headers: {
                'content-type': 'application/json',
                'X-SYF-Request-TrackingId': generateTransId(),
                'X-SYF-Request-CorrelationId': getCorrelationId()
            }
        })

        const that = this;

        this.setState({ loadingVisible: true });

        Axios.post(loginApiUrl, data, reqHeaders)
          .then(function (response) {
            const responseCode = response.data.status.response_code;
            const sessionId = response.data.session_id;

            // if success, forward to redirect uri with credentials
            if (responseCode === '1005') {
              //bubble up to parent in index
              that.props.onPush(sessionId, userId);
            } else {
              that.setState({
                loadingVisible: false,
              });
              that.setState({
                serviceError: errorMsgs[responseCode],
              });
            }
          })
          .catch(function (error) {
            // If error, hide loading screen, clear pwd, show error
            that.setState({
              loadingVisible: false,
            });
            that.setState({ password: '' });

            that.setState({
              serviceError: errorMsgs['400'],
            });
          });
    }

    render() {
        return (
            <div className="container login">
                <Helmet>
                    <title>{this.props.config.product} - Login</title>
                </Helmet>
                <h1>Log into Your Account</h1>
                <span className="alert-credential">
                    {this.props.config.notice_form}
                </span>
                {this.state.userIdError || this.state.pwdError ? (
                    <FormError />
                ) : null}
                {this.state.serviceError ? (
                    <ServiceError
                        errorMessage={this.state.serviceError[0]}
                        errorLink={this.state.serviceError[1]}
                        linkText={this.state.serviceError[2]}
                    />
                ) : null}
                <form onSubmit={this.handleSubmit}>
                    <SingleInput
                        label="User ID"
                        name="userid"
                        icon="fa fa-user"
                        inputType="text"
                        autoComplete="off"
                        error={this.state.userIdError}
                        value={this.state.userid}
                        controlFunc={this.handleChange}
                    />
                    <span className="userid-msg">
                        {this.props.config.notice_userid}
                    </span>

                    <SingleInput
                        label="Password"
                        name="password"
                        icon="fa fa-lock"
                        inputType="password"
                        error={this.state.pwdError}
                        value={this.state.password}
                        controlFunc={this.handleChange}
                    />

                    <input type="hidden" name="bm-telemetry"/>

                    <button
                        type="submit"
                        name="btnLogin"
                        className="ensightenvalidateevent"
                        data-label="Secure Login"
                    >
                        <i className="fa fa-lock" />
                        <span>Secure Login</span>
                    </button>
                </form>
                <div className="login-option">
                    <a href={this.props.config.account_register_url}>
                        Find User ID
                    </a>
                </div>
                <div className="login-option">
                    <a href={this.props.config.account_register_url}>
                        Reset Password
                    </a>
                </div>

                {this.state.loadingVisible ? <Loading /> : null}
            </div>
        );
    }
}
